import { getAuthUserInfoOrDefault } from '../network/cookie';
import * as Sentry from '@sentry/react';
import UserRole from '../chat/enums/UserRole';

const authInfo = getAuthUserInfoOrDefault();

const shouldEnableSentry = () => {
  if (
    import.meta.env.VITE_APP_STAGE !== 'production' ||
    import.meta.env.VITE_DISABLE_SENTRY === 'true'
  ) {
    return false;
  }

  return true;
};

export const createCustomLogger = (mustLog: boolean = false) => {
  const isEnabled = mustLog || import.meta.env.VITE_APP_STAGE !== 'production';

  return {
    setUser: (user: string) => {
      Sentry.setUser({ id: user });
    },
    leaveBreadcrumb: (
      message: string,
      metadata: { [key: string]: unknown } = {},
      category: string = 'request'
    ) => {
      if (import.meta.env.SSR || typeof window === 'undefined') {
        return;
      }
      const data = metadata || {};
      data['internet'] = window?.navigator?.onLine || 'na';

      Sentry.addBreadcrumb({
        type: 'default',
        level: 'info',
        category: category,
        message: message,
        data: data,
        timestamp: Date.now() / 1000
      });

      if (isEnabled) {
        console.log(message, metadata);
      }
    },
    debug: (message: string, ...params: any[]) => {
      if (isEnabled) {
        console.log(message, ...params);
      }
    },
    error: (message: string | Error, metadata: { [key: string]: unknown } = {}) => {
      Sentry.captureException(message, {
        data: metadata
      });
      console.error(message, metadata);
    }
  };
};

export const logger = createCustomLogger();
